import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Meetings from './pages/Meetings';
import Login from './pages/Login';
import ProfileSettings from './pages/ProfileSettings';
import LiveMeeting from './pages/LiveMeeting';
import RequireAuth from './components/auth/RequireAuth';
import { logApiConfig } from './utils/api';
import CacheManager from './utils/cacheManager';
import { FileRegistryProvider } from './contexts/FileRegistryContext';
import { AuthProvider } from './contexts/AuthContext';
import packageJson from '../package.json';

function App() {
  useEffect(() => {
    // Check cache version and clear if needed
    const checkCache = async () => {
      const needsReload = await CacheManager.checkAndClearCache(packageJson.version);
      if (needsReload) {
        // Small delay to ensure cache is cleared
        setTimeout(() => {
          CacheManager.forceHardReload();
        }, 100);
      }
    };

    checkCache();

    // Log API configuration on app startup (only in debug mode)
    logApiConfig();
  }, []);

  return (
    <AuthProvider>
      <FileRegistryProvider>
        <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
          <Layout>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/dashboard/create" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/dashboard/home" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/dashboard/projects" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/dashboard/project/:id" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/profile" element={<RequireAuth><ProfileSettings /></RequireAuth>} />
              <Route path="/meetings" element={<RequireAuth><Meetings /></RequireAuth>} />
              <Route path="/meetings/live" element={<RequireAuth><Meetings /></RequireAuth>} />
              <Route path="/meetings/:id/live" element={<RequireAuth><LiveMeeting /></RequireAuth>} />
              <Route path="/meetings/:id" element={<RequireAuth><Meetings /></RequireAuth>} />
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </Layout>
        </Router>
      </FileRegistryProvider>
    </AuthProvider>
  );
}

export default App;